import { Radar, Gem, Sparkles } from 'lucide-react';

/**
 * Composite "Brainstorm" icon — fuses Radar (probe/scan), Gem (the valuable
 * result), and Sparkles (the spark of an idea) into one funky mark.
 * Accepts a Tailwind sizing className (e.g. "h-5 w-5"); inherits text color.
 */
export default function BrainstormIcon({ className = '' }) {
  return (
    <span className={`relative inline-block ${className}`} aria-hidden="true">
      <Radar className="absolute inset-0 h-full w-full opacity-30" strokeWidth={2} />
      <Gem className="absolute left-1/2 top-[54%] h-[58%] w-[58%] -translate-x-1/2 -translate-y-1/2" strokeWidth={2} />
      <Sparkles className="absolute -right-px -top-px h-[44%] w-[44%]" strokeWidth={2.25} />
    </span>
  );
}
